export var convertFiltersForServer = function (filter) {
    if (!filter) {
        return {};
    }
    var result = {};
    if (filter.categories && filter.categories.length > 0) {
        result.category_ids = filter.categories.join(',');
    }
    if (filter.colors && filter.colors.length > 0) {
        result.color_family_keys = filter.colors.join(',');
    }
    if (filter.prices && filter.prices.length > 0) {
        result.price_range = "".concat(Math.round(filter.prices[0]), "-").concat(Math.round(filter.prices[1]));
    }
    if (filter.sizes) {
        Object.entries(filter.sizes).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            result["sizes.".concat(key)] = value.join('|');
        });
    }
    if (filter.brands && filter.brands.length > 0) {
        result.brand_codes = filter.brands.join(',');
    }
    if (filter.materials && filter.materials.length > 0) {
        result.material_codes = filter.materials.join(',');
    }
    return result;
};
export var convertFiltersForClient = function (filterData) {
    if (!filterData) {
        return {};
    }
    var _a = filterData.price_filter, pricesRange = _a === void 0 ? { min: 0, max: 0 } : _a, _b = filterData.category_filter, categories = _b === void 0 ? {} : _b, _c = filterData.size_filter, sizes = _c === void 0 ? {} : _c, _d = filterData.color_filter, colors = _d === void 0 ? [] : _d, _e = filterData.gender_filter, genderFilter = _e === void 0 ? [] : _e, _f = filterData.brand_filter, brandFilter = _f === void 0 ? [] : _f, _g = filterData.material_filter, materialFilter = _g === void 0 ? [] : _g;
    return {
        prices: [pricesRange.min, pricesRange.max],
        categories: categories,
        sizes: sizes,
        colors: colors,
        genderFilter: genderFilter,
        brandFilter: brandFilter,
        materialFilter: materialFilter,
    };
};
var CROSS_CAMPAIGN_KEY = 'category_id';
export var setCrossCampaignIdFromSessionStorage = function (selectedCategoryId) {
    try {
        sessionStorage.setItem(CROSS_CAMPAIGN_KEY, selectedCategoryId);
    }
    catch (e) {
        // ignore
    }
};
export var getCrossCampaignIdFromSessionStorage = function () {
    try {
        return sessionStorage.getItem(CROSS_CAMPAIGN_KEY);
    }
    catch (e) {
        return null;
    }
};
